import { gql } from "@apollo/client";

export const getGroups = gql`
  query {
    Groups {
      data
    }
  }
`;
